import './HAlternateLayoutItem.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { HLinkButton } from '../HLinkButton';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage } from '~/schemes';
import { AlternateLayoutItemModule } from '~/server-middleware/data-server/adapter/ACCOAdapter/@types';

export const HAlternateLayoutItem = tsx.component({
  name: 'HAlternateLayoutItem',
  functional: true,
  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          AlternateLayoutItemModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  render(h, { props }): VNode | VNode[] {
    const item = props.value;

    const imageUrl =
      item.image && item.image.derived && item.image.derived.main
        ? item.image.derived.main.url
        : '';

    return (
      <div
        key={item.key}
        class={[
          'h-alternate-layout-item',
          {
            'h-alternate-layout-item--reversed': props.reversed,
            'h-alternate-layout-item--has-background': item.hasBackground,
            'h-alternate-layout-item--no-image': !item.image,
          },
        ]}>
        <div class="h-alternate-layout-item__inner">
          {item.image && (
            <figure class="h-alternate-layout-item__image-wrapper">
              <img
                src={imageUrl}
                alt={item.caption || ''}
                class="h-alternate-layout-item__image"
              />
              {item.caption && (
                <figcaption class="h-alternate-layout-item__caption">
                  {item.caption}
                </figcaption>
              )}
            </figure>
          )}
          <div class="h-alternate-layout-item__content">
            {item.subTitle && (
              <div class="h-alternate-layout-item__sub-title">
                {item.subTitle}
              </div>
            )}
            {item.title && (
              <h3 class="h-alternate-layout-item__title">{item.title}</h3>
            )}
            {item.text && (
              <div class="h-alternate-layout-item__text">{item.text}</div>
            )}

            {item.hasLinkButton && item.linkButton.properties.text && (
              <div class="h-alternate-layout-item__link-button">
                <HLinkButton
                  value={item.linkButton.properties}
                  disableContainer={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
});
